import pyClient from '../PyAPI_Config'

async function get(authState: any, path: string) {
  return await pyClient(authState)
    .get<any>(path)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function patch(authState: any, path: string, data: any) {
  return await pyClient(authState)
    .patch<any>(path, data)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function put(authState: any, path: string, data?: any) {
  return await pyClient(authState)
    .put<any>(path, data)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function post(authState: any, path: string, data?: any) {
  return await pyClient(authState)
    .post<any>(path, data)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

// delete alone is a reserved name
async function deleteCall(authState: any, path: string) {
  return await pyClient(authState)
    .delete<any>(path)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const PyAPI = {
  get,
  patch,
  put,
  post,
  deleteCall,
}

export default PyAPI
